// Autogenerated file
export const messengerTypesEnum = {
    WhatsApp: "WhatsApp",
    Telegram: "Telegram",
};
export const messengerTypes = [
    { label: "WhatsApp", value: "WhatsApp" },
    { label: "Telegram", value: "Telegram" },
];
